// What the menu pages need to know about the site header, with no router or
// i18n behind it: the pages and the category bars import this, while the hook
// that moves the header (hooks/useHideHeaderOnScroll) writes what is read here.

// Where a pinned bar belongs right now, from the top of the screen: the header's
// height while the header shows, 0 once it has slid away. The hook publishes it
// as --site-header-offset on the root.
export const readHeaderOffset = () =>
  parseFloat(document.documentElement.style.getPropertyValue('--site-header-offset')) || 0;

// Keeps a bar's selected entry in view inside the bar. `block: 'nearest'` leaves
// the page alone while the whole bar is on screen, but scrolls the page to bring
// the bar into view when it is not (scrolled past, or half off the bottom): under
// the visitor's finger, and back up the page when the bar is not pinned. So it is
// only asked while the whole bar is on screen.
export const keepEntryInView = (bar, entry) => {
  if (!bar || !entry || typeof entry.scrollIntoView !== 'function') return;
  const { top, bottom } = bar.getBoundingClientRect();
  if (top < 0 || bottom > window.innerHeight) return;
  entry.scrollIntoView({ inline: 'center', block: 'nearest' });
};

// A scroll the page makes itself (a category tap moving the list under the
// bar) is not the visitor scrolling, so the header keeps its state through it.
// Module-level: there is one header.
let holdUntil = 0;
export const holdHeaderState = (ms = 150) => {
  holdUntil = Date.now() + ms;
};
export const isHeaderHeld = () => Date.now() < holdUntil;
